import {GoogleMapPin} from 'components/icons/GoogleMapPin';
import React, {CSSProperties} from 'react';

import './_cluster.scss';

interface Props {
    lat: number;
    lng: number;
    count: number;
    onClick?: () => void;
    children?: React.ReactNode;
    style?: CSSProperties;
}

export const Cluster: React.FunctionComponent<Props> = ({children: _children, count, onClick, style: _style}) => {

    return (
        <GoogleMapPin onClick={onClick} isCluster text={count.toString()}/>
    );

    /*
    return (
        <div className="cluster" onClick={onClick} style={style}>
            {count}
        </div>
    );

     */
};
